import { Link } from "react-router-dom";

export default function SafetySection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Content */}
          <div className="lg:w-1/2 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-4">
              Safety First
            </span>
            <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-5 leading-tight">
              Is VigorBuy Spreadsheet Safe?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              Understanding safety practices, payment precautions, shipping timelines, and buyer
              awareness can help users make informed decisions. The VigorBuy Spreadsheet itself is a
              resource and organization tool — it compiles product information and links for
              convenient browsing rather than processing transactions directly.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              We recommend following standard online shopping safety practices: always verify seller
              ratings before making a purchase, use secure payment methods, carefully read product
              reviews, and understand estimated shipping timelines. Being an informed shopper is the
              best way to have a positive experience.
            </p>
            <Link
              to="/article/vigorbuy-spreadsheet-safety"
              className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-500 text-primary-600 text-sm font-medium rounded-full hover:bg-primary-500 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Read Safety Guide
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-sm"></i>
              </div>
            </Link>
          </div>

          {/* Right Image */}
          <div className="lg:w-1/2 w-full">
            <div className="w-full h-[320px] md:h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20still%20life%20of%20a%20small%20modern%20desk%20with%20laptop%20showing%20secure%20checkout%20icon%20and%20open%20notebook%20with%20handwritten%20notes%2C%20gentle%20cream%20and%20beige%20tones%2C%20soft%20natural%20lighting%20from%20left%2C%20trust%20and%20security%20concept%2C%20editorial%20photography%2C%20calm%20reassuring%20aesthetic&width=800&height=600&seq=safety-vigorbuy-v3&orientation=landscape"
                alt="VigorBuy Spreadsheet safety and shopping guide"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}